import {createFileRoute} from '@tanstack/react-router'
import MatchDetailView from "../../../marketplace/MatchDetailView.tsx";

export const Route = createFileRoute('/_app/marketplace/games/$game_uid')({
    component: RouteComponent,
})

function RouteComponent() {
    return <MatchDetailView />
}
